let selectedItems = [],
    bulkActionsLoaded = false,
    searchParams = new URLSearchParams(window.location.search),
    selectedFoldersItems = [],
    selectedAll = false;

const selectOptionsBlock = jQuery('div.selectActionsBlock'),
    selectItem = jQuery('div.designGridItem-Select'),
    deselectAllItems = jQuery('div.selectActionButton-DeselectAll', selectOptionsBlock),
    selectBulkOptions = jQuery('ul.selectActionsBlockList li', selectOptionsBlock),
    popUpActions = jQuery('div.popupActions'),
    closePopUpAction = jQuery('div.userMenuCloseButton, div.popupPlatformOverlay', popUpActions),
    copyOptionButton = jQuery('li.selectActionItem-CopyTo', selectOptionsBlock),
    moveToOptionButton = jQuery('li.selectActionItem-MoveTo', selectOptionsBlock),
    selectMoveTo = jQuery("select[name='moveTo']", popUpActions),
    availableOptionsToMoveTo = jQuery('option', selectMoveTo),
    copyShareUrlToClipboardButton = jQuery('#copyShareUrlToClipboard', popUpActions),
    body = jQuery('body'),
    designActionFromView = jQuery('ul.designViewAction'),
    copyToDesignActionFromView = jQuery('li.copyToDesignActionFromView strong', designActionFromView),
    moveToDesignActionFromView = jQuery('li.moveToDesignActionFromView strong', designActionFromView),
    openShareFromDesignView = jQuery('.openShare'),
    submitBulkActionsFormHandler = jQuery('form#submitFormBulkActions'),
    submitFormActionsButton = jQuery('div.submitBulkActions', popUpActions),
    actionPreloader = jQuery('div.actionLoader'),
    shareWithForm = jQuery('form#shareWithEmail'),
    shareWithSubmitButton = jQuery('div.popupButtonYellow', shareWithForm),
    addFolderForm = jQuery('form.addFolder', 'li.foldersGridItem'),
    addFolderButton = jQuery('div.designGridItem-AddFolder', addFolderForm),
    selectAllDesigns = jQuery('div.selectActionButton-SelectAllDesigns', selectOptionsBlock);

function toggleSelectOptionBlock() {
    if (selectedItems.length <= 0) {
        if (selectOptionsBlock.hasClass('active')) {
            selectOptionsBlock.removeClass('active');
            body.removeClass('selectionActionsActive');
        }
    } else {
        if (!selectOptionsBlock.hasClass('active')) {
            selectOptionsBlock.addClass('active');
            body.addClass('selectionActionsActive');
            if (!bulkActionsLoaded) {
                loadBulkActionButtons();
            }
        }
    }
    checkIfSingleShareActionAvailability();
}

function loadBulkActionButtons() {
    selectBulkOptions.each(function () {
        let actionButton = jQuery(this);
        actionButton.unbind('click');
        actionButton.bind('click', function () {
            let $thisAction = jQuery(this),
                $thisActionTypeClass = $thisAction.attr('class').split(/\s(.+)/)[0],
                actionType = $thisActionTypeClass.replace('selectActionItem-', '');
            jQuery("div.popupActions[data-selection-action='" + actionType + "']").addClass('active');
            jQuery('input[name=selectedItemsActionType]', submitBulkActionsFormHandler).val(actionType);
        });
    });
    bulkActionsLoaded = true;
}

shareWithForm.on('keyup keypress', function (e) {
    let keyCode = e.keyCode || e.which;
    if (keyCode === 13) {
        e.preventDefault();
        return false;
    }
});

shareWithSubmitButton.unbind('click');
shareWithSubmitButton.bind('click', function () {
    let emails = jQuery('textarea[name="message"]').val().split(",");
    if (emails.length) {
        shareWithForm.submit();
    }
});

closePopUpAction.unbind('click');
closePopUpAction.bind('click', function () {
    let $this = jQuery(this);
    $this.closest('div.popupActions').removeClass('active');
    jQuery('option', selectMoveTo).filter('[data-folder-current="false"]').each(function (key, item) {
        jQuery(item).prop('disabled', false);
    });
    deselectAllItems.trigger('click');
});

deselectAllItems.unbind('click');
deselectAllItems.bind('click', function () {
    selectedItems.map(function (item) {
        jQuery("li[data-selection-id='" + item + "']").removeClass('active');
    });
    selectedItems = [];
    selectedFoldersItems = [];
    toggleSelectOptionBlock();
    checkMoveToBulkOptionAvailability();
    checkCopyToBulkOptionAvailability();
});

selectItem.unbind('click');
selectItem.bind('click', function () {
    let $this = jQuery(this),
        selectItemLi = $this.parent('li'),
        selectItemLiID = selectItemLi.data('selectionId');
    if (selectItemLi.hasClass('active')) {
        selectItemLi.removeClass('active');
        selectedItems.splice(selectedItems.indexOf(selectItemLiID), 1);
        if (!$.isNumeric(selectItemLiID)) {
            selectedFoldersItems.splice(selectedFoldersItems.indexOf(selectItemLiID), 1);
            availableOptionsToMoveTo.prop('disabled', false);
            checkMoveToBulkOptionAvailability();
            checkCopyToBulkOptionAvailability();
        }
    } else {
        selectItemLi.addClass('active');
        selectedItems.push(selectItemLiID);
        if (!$.isNumeric(selectItemLiID)) {
            selectedFoldersItems.push(selectItemLiID);
            checkMoveToBulkOptionAvailability();
            checkCopyToBulkOptionAvailability();
        }
    }
    toggleSelectOptionBlock();
});


selectAllDesigns.unbind('click');
selectAllDesigns.bind('click', function () {

    $.each(selectItem, function (key, item) {
        let $this = jQuery(item),
            selectItemLi = $this.parent('li'),
            selectItemLiID = selectItemLi.data('selectionId');
        if ($.isNumeric(selectItemLiID)) {
            $this.trigger('click');
        }
    });
});


function checkIfSingleShareActionAvailability() {
    const singleShareActionsForm = jQuery('.popupPlatformBlock > .singleShareActions');
    if (selectedItems.length == 1) {
        setShareUrlForSpecificDesign();
        singleShareActionsForm.removeClass('none');
    } else {
        singleShareActionsForm.addClass('none');
    }
    setEmailsInShareForm();
}

function setEmailsInShareForm() {
    let shareDesignIdsInput = jQuery('input[name="shareDesignIds"]', shareWithForm);
    if (shareDesignIdsInput.length) {
        shareDesignIdsInput.remove();
    }
    $('<input>').attr('type', 'hidden').attr('value', selectedItems.toString()).attr('name', 'shareDesignIds').appendTo(shareWithForm);
}

function setShareUrlForSpecificDesign() {
    let designId = selectedItems[0],
        encryptedDesignId = encryptId(designId),
        url = window.location.origin + '/sh/' + encryptedDesignId,
        designSelector = jQuery(".designGridItemImg", "li[data-selection-id='" + designId + "']");
    if (designSelector.length < 1) {
        designSelector = jQuery('.designViewItemInner');
    }
    if(designSelector.length){
        let designMetaDescription = jQuery("img", designSelector),
            imgSrc = designMetaDescription.attr('src'),
            title = designMetaDescription.attr('alt').replace('#', ''),
            isVideo = false,
            imgSrcToShare = '';
        if (imgSrc.indexOf(".gif") >= 0) {
            isVideo = true;
            imgSrcToShare = imgSrc.replace('.gif', '.mp4');
        } else {
            imgSrcToShare = imgSrc.replace('/thumbs/', '/');
        }
        let socialShareButtons = {
            'shareButtonsPopupFacebook': "https://www.facebook.com/sharer/sharer.php?u=" + url,
            'shareButtonsPopupTwitter': "https://twitter.com/intent/tweet?url=" + url + "&text=" + title + "&via=PixTeller&related=PixTeller,PhotoEditor,AnimationMaker,GifMaker",
            'shareButtonsPopupPinterest': "https://pinterest.com/pin/create/button/?url=" + url + "&media=" + imgSrcToShare + "&description=" + title + "&is_video=" + isVideo,
            'shareButtonsPopupLinkedin': "https://www.linkedin.com/sharing/share-offsite/?url=" + url,
            'shareButtonsPopupReddit': "https://www.reddit.com/submit?url=" + url + "&title=" + title,
            "shareButtonsPopupTumblr": "https://tumblr.com/share/link?url=" + url
        };
        jQuery.each(socialShareButtons, function (key, value) {
            jQuery('.' + key + ' > a').attr('href', encodeURI(value));
        });
        jQuery('textarea[name="DesignLink"]', popUpActions).val(url);
    }



}

copyShareUrlToClipboardButton.unbind('click');
copyShareUrlToClipboardButton.bind('click', copyLinkToClipboard);

function copyLinkToClipboard() {
    // Create a "hidden" input
    let aux = document.createElement("input"),
        designLink = jQuery('textarea[name="DesignLink"]', popUpActions);
    // Assign it the value of the specified element
    aux.setAttribute("value", designLink.val());

    // Append it to the body
    document.body.appendChild(aux);

    // Highlight its content
    aux.select();

    // Copy the highlighted text
    document.execCommand("copy");

    // Remove it from the body
    document.body.removeChild(aux);
    let button = jQuery('span', this);
    button.text('Copied')
        .parent().css('background', '#DDD');
    setTimeout(function () {
        button.text('Copy')
            .parent().css('background', '');

    }, 3000);
}

function checkMoveToBulkOptionAvailability() {
    selectedFoldersItems.filter(function (value) {
        let moveToFolderBlockSelector = jQuery("option[data-action-folder-id='" + value + "']", selectMoveTo);

        moveToFolderBlockSelector.prop('disabled', true);
        availableOptionsToMoveTo.each(function (key, item) {
            let $item = jQuery(item);
            if ($item.data('actionFolderId') === value) {
                $item.nextAll().each(function (key, needDisabled) {
                    let $needDisabled = jQuery(needDisabled);
                    if ($item.data('folderLevel') !== $needDisabled.data('folderLevel')) {
                        $needDisabled.prop('disabled', true);
                    } else {
                        return false;
                    }
                });
                $item.prop('disabled', true);
            }
        })
    });
    if (searchParams.has('folder')) {
        jQuery("option[data-action-folder-id='" + searchParams.get('folder') + "']", selectMoveTo).prop('disabled', true);
    } else if (jQuery('div.designViewBlock').length <= 0) {
        jQuery("option[data-action-folder-id='my-designs']", selectMoveTo).prop('disabled', true);
    }
    if (jQuery("option:enabled", selectMoveTo).length <= 0) {
        jQuery('li.selectActionItem-MoveTo', selectOptionsBlock).hide();
    } else {
        jQuery('li.selectActionItem-MoveTo', selectOptionsBlock).show();
    }
    let availableMoveToFoldersCount = availableOptionsToMoveTo.filter(':enabled').length;
    if (availableMoveToFoldersCount === 0 && moveToOptionButton.is(':visible')) {
        moveToOptionButton.hide();
    } else if (availableMoveToFoldersCount > 0 && moveToOptionButton.is(':hidden')) {
        jQuery("option:enabled", selectMoveTo).first().attr('selected', 'selected');
        moveToOptionButton.show();
    }
}

function checkCopyToBulkOptionAvailability() {
    if (selectedFoldersItems.length > 0) {
        copyOptionButton.hide();
    } else if (selectedFoldersItems.length === 0) {
        copyOptionButton.show();
    }
}

function encryptId(idClean) {
    const key = 'pixtelrcom'.split('');
    let encryptedId = '';
    String(idClean).split('').forEach(function (i) {
        encryptedId += key[i];
    });

    return encryptedId;
}

submitBulkActionsFormHandler.on('submit', function () {
    let $this = jQuery(this);
    if (jQuery('input[name=selectedItemsActionType]', $this).val() === 'Download') {
        setTimeout(function () {
            if (actionPreloader.hasClass('active')) {
                deselectAllItems.trigger('click');
                closePopUpAction.trigger('click');
                jQuery('div.popupActions').removeAttr("style");
                actionPreloader.removeClass('active');
            }
        }, 2500 * selectedItems.length);
    }
});

submitFormActionsButton.unbind('click');
submitFormActionsButton.bind('click', function () {
    let $this = jQuery(this),
        $thisPopupContainer = $this.closest('div.popupActions.active');
    $thisPopupContainer.hide();
    actionPreloader.addClass('active');
    if ($thisPopupContainer.length >= 0) {
        jQuery('input[name=selectedItemsActionOption]', submitBulkActionsFormHandler).val($thisPopupContainer.find("option:selected").val());
    }
    jQuery('input[name=selectedItems]', submitBulkActionsFormHandler).val(selectedItems.join(","));
    submitBulkActionsFormHandler.submit();

});

openShareFromDesignView.unbind('click');
openShareFromDesignView.bind('click', function () {
    deselectAllItems.trigger('click');

    if (jQuery("div.popupActions[data-selection-action='ShareWith']").length > 0) {
        jQuery("div.popupActions[data-selection-action='ShareWith']").addClass('active');
    } else {
        jQuery("div.popupActions[data-selection-action='GetPro']").addClass('active');
    }
    selectedItems.push(jQuery('div.designViewBlock').data('selectionId'));
    checkIfSingleShareActionAvailability();
});

copyToDesignActionFromView.unbind('click');
copyToDesignActionFromView.bind('click', function () {
    deselectAllItems.trigger('click');
    availableOptionsToMoveTo.filter("option:enabled").first().attr('selected', 'selected');

    if (jQuery("div.popupActions[data-selection-action='CopyTo']").length > 0) {
        jQuery("div.popupActions[data-selection-action='CopyTo']").addClass('active');
    } else {
        jQuery("div.popupActions[data-selection-action='GetPro']").addClass('active');
    }
    jQuery('input[name=selectedItemsActionType]', submitBulkActionsFormHandler).val('CopyTo');
    selectedItems.push(jQuery('div.designViewBlock').data('selectionId'));
});

moveToDesignActionFromView.unbind('click');
moveToDesignActionFromView.bind('click', function () {
    deselectAllItems.trigger('click');
    let $folderData = jQuery('div.designViewBlock');
    selectedItems.push($folderData.data('selectionId'));
    jQuery('input[name=selectedItemsActionType]', submitBulkActionsFormHandler).val('MoveTo');
    availableOptionsToMoveTo.filter("[data-action-folder-id='" + $folderData.data('designFolderId') + "']").prop('disabled', true);
    availableOptionsToMoveTo.filter("option:enabled").first().attr('selected', 'selected');
    jQuery("div.popupActions[data-selection-action='MoveTo']").addClass('active');
});


addFolderButton.unbind('click');
addFolderButton.bind('click', function () {
    addFolderForm.submit();
});

addFolderForm.on('submit', function () {
    let $this = jQuery(this);
    $this.submit(function () {
        return false;
    });
    // submit once return true
    return true;
});


